<template>
    <div class="viewBox">
        <div class="editor">
            <div class="left">
               <div class="header old-can" ref="ocBox">
                    <div class="oc-box">
                        <img :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/smartCutout/${photoList[photoActiveIndex].url}`" alt="">
                        <canvas width="400" height="267"  @mousedown="checkTarget" ref="oldCanvas" id="old-canvas"></canvas>
                    </div>
                    <div class="round-box" :class="roundClass" :style="roundBlock"></div>
                    <div class="list">
                        <button @click="changePhoto(index)" :class="photoActiveIndex==index ? 'photoActive':''" v-for="(item,index) in photoList" :key="index">
                            <img :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/smartCutout/${item.url}`" >
                        </button>
                    </div>
                    <div class="tool">
                           <div>
                               <button title="保留" @click="toolStatusChange(1)" :class="toolActiveIndex==1 ? '_1JQcs':''" class="_2Jkr7 _3yhJv">
                                   <svg width="18" height="18"><path d="M2.025 2.025V0h1.35v2.025H5.4v1.35H3.375V5.4h-1.35V3.375H0v-1.35h2.025zM18 9.474V9.9H4.5v-.42a2.668 2.668 0 01.838-1.944 2.877 2.877 0 012.004-.8h1.741l.002-4.695C9.085.916 10.05 0 11.235 0c.571 0 1.105.214 1.503.602.394.384.61.895.61 1.44l-.002 4.694h1.785c.759 0 1.477.286 2.022.804.546.52.847 1.207.847 1.934zM4.01 15.23V11.7H18v3.53c0 1.528-1.321 2.77-2.945 2.77H1.8v-1.385h.736c.812 0 1.473-.62 1.473-1.384z" fill="#515666" fill-rule="evenodd"></path></svg>
                                   保留
                                </button>
                                <button title="扣去" @click="toolStatusChange(2)" :class="toolActiveIndex==2 ? '_1JQcs':''" class="_2Jkr7 R_Kz8 _3yhJv">
                                    <svg width="18" height="18"><path d="M0 2.025h5.4v1.35H0v-1.35zm18 7.449V9.9H4.5v-.42a2.668 2.668 0 01.838-1.944 2.877 2.877 0 012.004-.8h1.741l.002-4.695C9.085.916 10.05 0 11.235 0c.571 0 1.105.214 1.503.602.394.384.61.895.61 1.44l-.002 4.694h1.785c.759 0 1.477.286 2.022.804.546.52.847 1.207.847 1.934zM4.01 15.23V11.7H18v3.53c0 1.528-1.321 2.77-2.945 2.77H1.8v-1.385h.736c.812 0 1.473-.62 1.473-1.384z" fill="#515666" fill-rule="evenodd"></path></svg>
                                    扣去
                                </button>
                                <button title="橡皮擦" @click="toolStatusChange(3)" :class="toolActiveIndex==3 ? '_1JQcs':''" class="_2Jkr7 R_Kz8 _3yhJv">
                                    <svg width="17" height="16"><g fill="#515666" fill-rule="evenodd"><path d="M9.62 12.913L3.534 6.826l5.78-5.78a2 2 0 012.829 0l3.258 3.26a2 2 0 010 2.828l-5.78 5.78z"></path><path d="M5.399 15.305L1.304 11.21a1.8 1.8 0 010-2.546L9.273.695a1.8 1.8 0 012.545 0l4.095 4.095a1.8 1.8 0 010 2.546l-7.968 7.969a1.8 1.8 0 01-2.546 0zm.636-.637a.9.9 0 001.273 0L15.277 6.7a.9.9 0 000-1.273l-4.095-4.095a.9.9 0 00-1.273 0L1.94 9.3a.9.9 0 000 1.273l4.095 4.095z" fill-rule="nonzero"></path><path fill-rule="nonzero" d="M7.273 15.823h9.391v-1H7.273z"></path></g></svg>
                                    橡皮擦
                                </button>
                            </div>
                            <div>
                                <button title="上一步" class="_2Jkr7 _3yhJv" @click="back">
                                    <svg width="18" height="18"><path d="M9.063.9C6.679.9 4.755 2.008 3.424 3.373l.043-.302a1.008 1.008 0 00-.844-1.141 1.001 1.001 0 00-1.13.852L.91 6.832c-.05.355.09.712.368.935.177.14.396.217.62.217a.982.982 0 00.37-.071l3.756-1.514c.51-.206.76-.792.557-1.306a.993.993 0 00-1.297-.565l-.29.116C6.126 3.566 7.6 2.914 9.09 2.914c2.905.014 6.014 2.463 6.014 6.086 0 3.357-2.696 6.086-6.01 6.086-2.906 0-4.684-2.346-5.16-3.066a.994.994 0 00-1.387-.276 1.013 1.013 0 00-.273 1.396c.614.929 2.924 3.96 6.82 3.96 4.415 0 8.006-3.633 8.006-8.1 0-4.37-3.664-8.079-8.037-8.1" fill="#515666" fill-rule="evenodd"></path></svg>
                                    上一步
                                </button>
                                <button title="下一步"  class="_2Jkr7 _3yhJv"  @click="next">
                                        <svg width="18" height="18"><path d="M8.937.9c2.384 0 4.308 1.108 5.639 2.473l-.043-.302a1.008 1.008 0 01.844-1.141 1.001 1.001 0 011.13.852l.583 4.05c.05.355-.09.712-.368.935-.177.14-.396.217-.62.217a.982.982 0 01-.37-.071l-3.756-1.514a1.011 1.011 0 01-.557-1.306.993.993 0 011.297-.565l.29.116c-1.132-1.078-2.606-1.73-4.096-1.73C6.005 2.928 2.896 5.377 2.896 9c0 3.357 2.696 6.086 6.01 6.086 2.906 0 4.684-2.346 5.16-3.066a.994.994 0 011.387-.276c.456.308.579.934.273 1.396-.614.929-2.924 3.96-6.82 3.96C4.49 17.1.9 13.467.9 9 .9 4.63 4.564.921 8.937.9" fill="#515666" fill-rule="evenodd"></path></svg>
                                    下一步
                                </button>
                                <button title="重做" class="_2Jkr7 _3yhJv" @click="defaultImage">
                                        <svg width="18" height="18"><path d="M1.909 9.754A.997.997 0 01.9 8.77C.9 4.525 4.616.92 9.015.9c2.224 0 4.042.897 5.372 2.057l-.06-.405a.958.958 0 01.18-.721c.162-.217.4-.358.672-.396.552-.073 1.064.3 1.143.83l.593 3.933a.974.974 0 01-.376.918 1.027 1.027 0 01-.994.14l-3.813-1.469a.992.992 0 01-.56-.536.959.959 0 01-.005-.746c.197-.48.745-.717 1.247-.56-1.01-.677-2.184-1.077-3.365-1.077-2.974.014-6.131 2.389-6.131 5.902a.997.997 0 01-1.01.984zM16.09 8.246a.997.997 0 011.009.984c0 4.246-3.716 7.85-8.116 7.87h-.039c-2.209 0-4.022-.904-5.35-2.071l.057.377a.957.957 0 01-.183.722 1.003 1.003 0 01-.816.405c-.497 0-.926-.361-.998-.84l-.593-3.933a.972.972 0 01.376-.918c.282-.213.662-.266.992-.14l3.815 1.469a.993.993 0 01.56.534c.103.24.104.505.005.748a1.017 1.017 0 01-1.303.55c1.026.71 2.232 1.13 3.442 1.13 2.975-.014 6.133-2.389 6.133-5.903a.997.997 0 011.01-.984z" fill="#515666" fill-rule="evenodd"></path></svg>
                                        重做
                                </button>
                            </div>
                    </div>
                    <!-- <div class="button">
                        <button>提交</button>
                    </div> -->
               </div>
            </div>
            <div class="right">
                <div class="workbeach">
                    <div class="background">
                        <div class="item">
                            <!-- <img :src="root.newImageBase64" > -->
                             <canvas
                                ref="downloadCanvas"
                                id="download-canvas"
                                width="800"
                                height="532"
                                v-loading="loading"
                            ></canvas>
                            <canvas
                                ref="bgCanvasBottom"
                                id="bg-canvas-bottom"
                                width="800"
                                height="532"
                                v-loading="loading"
                            ></canvas>
                            <canvas
                                @mousedown="checkTarget"
                                ref="newCanvas"
                                id="new-canvas"
                                width="800"
                                height="532"
                                v-loading="loading"
                            ></canvas>
                        </div>
                    </div>
                </div>
                 <canvas
                    id="upload-canvas"
                    width="852"
                    height="570.58"
                    style="
                position: fixed;
                z-index: 2000;
                bottom: -300px;
                right: 0;
                display: none;"></canvas>
                <canvas
                    id="eraser-canvas"
                    width="852"
                    height="570.58"
                    style="
                position: fixed;
                z-index: 2000;
                bottom: 0;
                right: 0;
                display: none;"></canvas>
            </div>
        </div>
    </div>
</template>
<script>

import { cutOutImage } from "@/config/axios/new_api";
export default {
    data(){
        return{
            photoList:[
                {
                    url:'1.jpg',
                    cutUrl:'https://ailab-test-img.oss-cn-beijing.aliyuncs.com/image/VCG211130574526.jpg'
                },
                 {
                    url:'2.jpg',
                    cutUrl:'https://ailab-test-img.oss-cn-beijing.aliyuncs.com/image/VCG211143796344.jpg'
                },
                 {
                    url:'3.jpg',
                    cutUrl:'https://ailab-test-img.oss-cn-beijing.aliyuncs.com/image/VCG21d297c35ee.jpg'
                },
                 {
                    url:'4.jpg',
                    cutUrl:'https://ailab-test-img.oss-cn-beijing.aliyuncs.com/image/VCG21gic20072100.jpg'
                },
            ],
            photoActiveIndex:0,
            poolList:[],
            toolActiveIndex:1,
            root:{
                canOperate: false, // 能操作标识
                request_id:'',
                newImageBase64: '', // 抠图
            },
             rootBgData: { content: '', type: '' }, // 根上的背景数据
           initLoading: false,
                loading: false,
                loadingConfig: {
                    backgroundColor: 'rgba(0,0,0, .6)',
                    text: '抠图初始化中',
                },
                config: {
                    // 图片配置
                    imgZoom: 0.2,
                    imgDefaultWidth: 903,
                    imgDefaultHeight: 762,
                },
                activeNameNum: 1, // 1 保留  2 去除  3 擦除  5 拖拽
                brushStatus: false, // 画笔状态
                newImageUrl: '',
                oldImageUrl: '',
                request_id: '',//'beb2ab4c-b45e-11eb-950b-00163e32a40e',
                oldImgList: [],
                newImgList: [],
                uploadImgList: [],
                canvasConfig: {
                    scale: 1,
                    oldImgScale: 1,
                    oldImg: null,
                    oldOffsetLeft: 0,
                    oldOffsetTop: 0,
                },
                canvasBrushType: {
                    // 笔画设置
                    globalCompositeOperation: 'source-over',
                    lineWidth: 12,
                    color: '#67c23a',
                },
                oldCanvas: null,
                newCanvas: null,
                bgCanvasBottom: null,
                uploadCanvas: null, // 后期用于上传
                eraserCanvas: null, // 用于恢复原图
                downloadCanvas: null, //
                step: -1,
        }
    },
    computed: {
        roundBlock () {
        // 拖动的圆圈是否显示
        return [1, 2, 3].includes(this.activeNameNum)
            ? `font-size: ${this.canvasBrushType.lineWidth}px;`
            : 'display:none'
        },
        roundClass () {
        let className = ''
        switch (this.activeNameNum) {
            case 1:
            className = 'iconfont icon-jia el-icon-circle-plus-outline'
            break
            case 2:
            className = 'iconfont icon-quchuicon el-icon-remove-outline'
            break
            case 3:
            className = 'iconfont icon-cachuicon el-icon-brush'
        }
        return className
        },
        cssLoading () {
        return this.loading ? 'z-index: 500' : 'z-index: 0'
        }
    },
    watch: {
        rangeVal (newVal) {
        this.inputVal = newVal
        this.canvasBrushType.lineWidth = newVal
        },
        'canvasConfig.scale': {
        // 监听scale 发生变化
        handler: function (newVal) {
            let { oldCanvas, newCanvas, uploadCanvas, eraserCanvas, bgCanvasBottom, downloadCanvas } = this.getElement()
            oldCanvas.style.transform = `scale(${newVal})`
            // newCanvas.style.transform = `scale(${newVal})`
            // bgCanvasBottom.style.transform = `scale(${newVal})`
            // downloadCanvas.style.transform = `scale(${newVal})`
            uploadCanvas.style.transform = `scale(${newVal})`
            eraserCanvas.style.transform = `scale(${newVal})`
        },
        },
    },
    mounted () {
          this.cutInit();
        // this.loadingConfig.text = '抠图初始化中'

        // // 打开上传提示
        // if ($.mytools.GetQueryString('u')) {
        // this.$confirm('上传图片支持jpg/png格式', '温馨提示', {
        //     confirmButtonText: '立即上传',
        //     showCancelButton: false,
        //     closeOnClickModal: false,
        //     type: 'warning'
        // }).then(() => {
        //     this.$refs['upload'].$children[0].$refs.input.click()
        // }).catch(() => {
        //     let url = window.location.href
        //     window.history.replaceState({}, 0, url.split('&')[0])
        // })
        // }

    },
    methods:{
        changePhoto(index){
            this.photoActiveIndex = index;
            this.cutInit();
        },
        toolStatusChange(index){
            this.toolActiveIndex = index
            this.toggleActiveName(index)
        },
        cutInit(){
            this.oldImageUrl = this.photoList[this.photoActiveIndex].cutUrl;
            let formdata = new FormData();
            formdata.append('image', this.photoList[this.photoActiveIndex].cutUrl)
            formdata.append('image_type', 'url');
            formdata.append('origin', 3);
            cutOutImage.imageCutout(formdata).then((res)=>{
               if(res.status == 1){
                    this.root.newImageBase64 = res.data.result;
                    this.root.request_id = res.data.request_id;
                    this.getInit(this.oldImageUrl,this.root.newImageBase64,this.root.request_id)
               }
            })
        },
        beforeUpload (file) {
        this.initLoading = true
        const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isImg) {
            this.$message.warning('上传图片只能是JPG或PNG格式')
            setTimeout(() =>{
            this.initLoading = false
            let url = window.location.href
            window.history.replaceState({}, 0, url.split('&')[0])
            },3000)
            return false
        }
        if (!isLt2M) {
            this.$message.warning('上传图片大小不能超过 10MB!')
            setTimeout(() =>{
            this.initLoading = false
            let url = window.location.href
            window.history.replaceState({}, 0, url.split('&')[0])
            },3000)
            return false
        }
        },
        handleSuccess (res) {
        if (res.status != 1) {
            this.$message.warning('上传失败，请重新上传')
            this.initLoading = false
            return
        }

        let _this = this

        let params = {
            url: '/koutu/image/save',
            type: 'POST',
            parameter: {
            url: res.data,
            },
            successFun: function (backData) {
            statistics.__sendEvent({
                statsMark: '抠图上传成功次数',
                projectPage: '24',
                projectArea: '47',
                eventArea: '47',
                eventType: '3',
                eventId: '77',
                eventName: 'cutout_upload_success_num',
            })
            _this.initLoading = false
            window.location.href = '/cutout/workbench?img_id=' + backData.data.id
            },
            errorFun: function (backData) {

            },
            serverErrorFun: function (serverErrorInfo) {

            }
        }

        common.requestInterface(params)
        },
        changePage (type) {
        this.$emit('change-page', type)
        if (type === 'bg') {
            this.$emit('set-new-image', this.getNewImageBase64())
        }
        },
        // cutoutInit (uploadImageUrl) {
        // this.initLoading = true
        // this.oldImageUrl = uploadImageUrl
        // let _this = this
        // let params = {
        //     url: '/image/cutout',
        //     type: 'POST',
        //     parameter: {
        //     image: this.oldImageUrl,
        //     image_type: 'url',
        //     origin: 3
        //     },
        //     successFun: function (backData) {
        //     _this.initLoading = false
        //     _this.newImageUrl = backData.data.result
        //     _this.request_id = backData.data.request_id
        //     _this.getInit()
        //     // 传递给根缓存request_id
        //     _this.$emit('set-request-id', backData.data.request_id)
        //     },
        //     errorFun: function (backData) {
        //     _this.initLoading = false
        //     _this.$message.closeAll()
        //     _this.$message({
        //         message: `${backData.msg}`,
        //         type: 'warning'
        //     })
        //     },
        //     serverErrorFun: function (serverErrorInfo) {
        //     // that.errorMsg = '服务出错'
        //     // that.errorDiaLogVisiable = true
        //     }
        // }

        // common.requestInterface(params)
        // },

        getInit (oldImageUrl, newImageUrl, request_id) {
        if (oldImageUrl && newImageUrl && request_id) {
            this.oldImageUrl = oldImageUrl
            this.newImageUrl = newImageUrl
            this.request_id = request_id
        }

        // 重置fabric对象
        this.oldCanvas && this.oldCanvas.clear()
        this.newCanvas && this.newCanvas.clear()
        this.uploadCanvas && this.uploadCanvas.clear()
        this.eraserCanvas && this.eraserCanvas.clear()
        this.bgCanvasBottom && this.bgCanvasBottom.clear()
        this.downloadCanvas && this.downloadCanvas.clear()

        // 获取canvas dom元素
        let {
            oldCanvas,
            newCanvas,
            bgCanvasBottom,
            downloadCanvas,
            uploadCanvas,
            eraserCanvas,
        } = this.getElement()

        this.oldCanvas = new fabric.StaticCanvas('old-canvas')
        this.newCanvas = new fabric.StaticCanvas('new-canvas')
        this.bgCanvasBottom = new fabric.StaticCanvas('bg-canvas-bottom')
        this.downloadCanvas = new fabric.StaticCanvas('download-canvas')
        this.uploadCanvas = new fabric.StaticCanvas('upload-canvas')
        this.eraserCanvas = new fabric.StaticCanvas('eraser-canvas')

        fabric.Object.prototype.transparentCorners = false
        this.loading = true
        fabric.Image.fromURL(
            this.oldImageUrl,
            (oldImg) => {

            let oldImgScale = 0 // 缩放比例
            if (oldImg.width > oldImg.height) {
                oldImgScale = 400 / oldImg.width
            } else {
                oldImgScale = 266 / oldImg.height
            }
            oldImgScale = Math.max(0.2, oldImgScale)
            oldImgScale = oldImgScale.toFixed(2) * 1

            this.uploadCanvas.setWidth(oldImg.width)
            this.uploadCanvas.setHeight(oldImg.height)
            this.eraserCanvas.setWidth(oldImg.width)
            this.eraserCanvas.setHeight(oldImg.height)
            // this.newCanvas.setWidth(oldImg.width)
            // this.newCanvas.setHeight(oldImg.height)
            // this.bgCanvasBottom.setWidth(oldImg.width)
            // this.bgCanvasBottom.setHeight(oldImg.height)
            // this.downloadCanvas.setWidth(oldImg.width)
            // this.downloadCanvas.setHeight(oldImg.height)
            this.oldCanvas.setWidth(oldImg.width)
            this.oldCanvas.setHeight(oldImg.height)

            oldCanvas.width = newCanvas.width = bgCanvasBottom.width = downloadCanvas.width = uploadCanvas.width = eraserCanvas.width =
                oldImg.width
            oldCanvas.height = newCanvas.height = bgCanvasBottom.height = downloadCanvas.height = uploadCanvas.height = eraserCanvas.height =
                oldImg.height

            this.oldCanvas.add(oldImg)
            // this.eraserCanvas.add(oldImg)

            this.canvasConfig = {
                oldImgScale, // 此值后续用来后续恢复原图使用。
                scale: oldImgScale,
                oldImg,
            }

            this.setScale() // 先更改transform  定位置
            this.setCss() // 再去设置图片的定位

            fabric.Image.fromURL(
                this.newImageUrl,
                (newImg) => {
                   
                // if (oldImg.width > newImg.width) {
                //     newImg.set({
                //     left: (oldImg.width - newImg.width) / 2,
                //     top: (oldImg.height - newImg.height) / 2,
                //     })
                // }
                 newImg.set({
                   width:852,
                   height:566.58
                })

                this.newCanvas.add(newImg)
                this.eraserCanvas.add(oldImg)
                // this.actionZoom() // 放大缩小
                this.actionBrush()
                this.loading = false
                this.loadingConfig.text = '处理中'

                // 获取base64并赋值
                this.oldImageUrl = oldCanvas.toDataURL()

                // 设置背景
                this.changeBackground()
                },
                {
                crossOrigin: 'Anonymous',
                }
            )
            },
            {
            crossOrigin: 'Anonymous',
            }
        )
        },
        getElement () {
        let oldCanvas = document.getElementById('old-canvas')
        let newCanvas = document.getElementById('new-canvas')
        let bgCanvasBottom = document.getElementById('bg-canvas-bottom')
        let downloadCanvas = document.getElementById('download-canvas')
        let uploadCanvas = document.getElementById('upload-canvas')
        let eraserCanvas = document.getElementById('eraser-canvas')
        let ctx = oldCanvas.getContext('2d')
        let newCtx = newCanvas.getContext('2d')
        let bgCtx = bgCanvasBottom.getContext('2d')
        let downloadCtx = bgCanvasBottom.getContext('2d')
        let uploadCtx = uploadCanvas.getContext('2d')
        let eraserCtx = eraserCanvas.getContext('2d')
        return {
            oldCanvas,
            newCanvas,
            bgCanvasBottom,
            downloadCanvas,
            uploadCanvas,
            ctx,
            newCtx,
            bgCtx,
            uploadCtx,
            downloadCtx,
            eraserCanvas,
            eraserCtx,
        }
        },
        setCss () {
        let { oldCanvas, newCanvas, bgCanvasBottom, downloadCanvas } = this.getElement()
        oldCanvas.style.top = 0
        oldCanvas.style.left = 0
        newCanvas.style.top = 0
        newCanvas.style.left = 0
        bgCanvasBottom.style.top = 0
        bgCanvasBottom.style.left = 0
        downloadCanvas.style.top = 0
        downloadCanvas.style.left = 0
        let { scale, oldImg } = this.canvasConfig
        let { top, left } = $('#old-canvas').offset()
        let boxOffsetTop = $('.oc-box').offset().top
        let boxOffsetLeft = $('.oc-box').offset().left
        let { width, height } = oldImg

        // 图片定位参数 需要保存 用于后期的合适大小
        this.canvasConfig.oldOffsetLeft = -(left - boxOffsetLeft) + ($('.oc-box').width() - width * scale) / 2
        this.canvasConfig.oldOffsetTop = -(top - boxOffsetTop) + ($('.oc-box').height() - height * scale) / 2

        oldCanvas.style.top = `${this.canvasConfig.oldOffsetTop}px`
        oldCanvas.style.left = `${this.canvasConfig.oldOffsetLeft}px`
        // newCanvas.style.top = `${this.canvasConfig.oldOffsetTop}px`
        // newCanvas.style.left = `${this.canvasConfig.oldOffsetLeft}px`
        // bgCanvasBottom.style.top = `${this.canvasConfig.oldOffsetTop}px`
        // bgCanvasBottom.style.left = `${this.canvasConfig.oldOffsetLeft}px`
        // downloadCanvas.style.top = `${this.canvasConfig.oldOffsetTop}px`
        // downloadCanvas.style.left = `${this.canvasConfig.oldOffsetLeft}px`
        },
        setScale () {
        // 默认进入弹出框 需要使用定位
        let { oldCanvas, newCanvas, uploadCanvas, eraserCanvas, bgCanvasBottom, downloadCanvas } = this.getElement()
        let { scale } = this.canvasConfig
        oldCanvas.style.transform = `scale(${scale})`
        // newCanvas.style.transform = `scale(${scale})`
        // bgCanvasBottom.style.transform = `scale(${scale})`
        // downloadCanvas.style.transform = `scale(${scale})`
        eraserCanvas.style.transform = `scale(${scale})`
        uploadCanvas.style.transform = `scale(${scale})`
        },
        // 关于图片的放大缩小操作
        actionZoom () {
        window.onmousewheel = (ev) => {
            if (this.loading) return // 如果存在加载状况， 证明状态还未返回
            var delta = ev.deltaY
            this.canvasConfig.scale *= 0.999 ** delta
            if (this.canvasConfig.scale >= 3) {
            this.canvasConfig.scale = 3
            }
            if (this.canvasConfig.scale <= 0.2) {
            this.canvasConfig.scale = 0.2
            }
        }
        },
        // 拖拽  拖拽左方的元素
        // actionDrag () {
        // if (this.activeNameNum !== 5) return
        // let { oldCanvas, newCanvas, bgCanvasBottom, downloadCanvas } = this.getElement() // 把所有获取属性 从这里读取
        // let dragPos = {
        //     x: 0,
        //     y: 0,
        //     l: 0,
        //     t: 0,
        //     isDown: false,
        // }
        // window.onmousedown = (e) => {
        //     if (this.loading) return // 如果存在加载状况， 证明状态还未返回
        //     if (!(e.target.getAttribute('id') && (e.target.getAttribute('id') === 'old-canvas' || e.target.getAttribute('id') === 'new-canvas'))) return

        //     let eId = e.target.getAttribute('id')
        //     let targetDom = $('#' + eId)
        //     let leftStart
        //     let leftEnd
        //     let topStart
        //     let topEnd

        //     // if (e.target.getAttribute('id') === 'new-canvas') {
        //     //   leftStart = $('#new-canvas').offset().left // 获取图片宽度初始位置
        //     //   leftEnd = leftStart + $('#new-canvas').innerWidth() * this.canvasConfig.scale // 获取图片最大宽度
        //     //   topStart = $('#new-canvas').offset().top
        //     //   topEnd = topStart + $('#new-canvas').innerHeight() * this.canvasConfig.scale
        //     // } else if (e.target.getAttribute('id') === 'old-canvas') {
        //     //   leftStart = $('#old-canvas').offset().left // 获取图片宽度初始位置
        //     //   leftEnd = leftStart + $('#old-canvas').innerWidth() * this.canvasConfig.scale // 获取图片最大宽度
        //     //   topStart = $('#old-canvas').offset().top
        //     //   topEnd = topStart + $('#old-canvas').innerHeight() * this.canvasConfig.scale
        //     // }

        //     leftStart = targetDom.offset().left // 获取图片宽度初始位置
        //     leftEnd = leftStart + targetDom.innerWidth() * this.canvasConfig.scale // 获取图片最大宽度
        //     topStart = targetDom.offset().top
        //     topEnd = topStart + targetDom.innerHeight() * this.canvasConfig.scale

        //     if (
        //     e.x >= leftStart &&
        //     e.x <= leftEnd &&
        //     e.y >= topStart &&
        //     e.y <= topEnd
        //     ) {
        //     dragPos.x = e.clientX
        //     dragPos.y = e.clientY

        //     // 获取左部的偏移量
        //     if (eId === 'old-canvas') {
        //         dragPos.l = oldCanvas.offsetLeft
        //         dragPos.t = oldCanvas.offsetTop
        //         oldCanvas.style.cursor = 'pointer'
        //     } else if (eId === 'new-canvas') {
        //         dragPos.l = newCanvas.offsetLeft
        //         dragPos.t = newCanvas.offsetTop
        //         newCanvas.style.cursor = 'pointer'
        //     }

        //     dragPos.isDown = true

        //     }
        // }

        // window.onmousemove = (e) => {
        //     $('.old-can').css({
        //     cursor: 'pointer'
        //     })
        //     if (this.loading) return // 如果存在加载状况， 证明状态还未返回
        //     if (!dragPos.isDown) return
        //     //获取x和y
        //     var nx = e.clientX
        //     var ny = e.clientY
        //     //计算移动后的左偏移量和顶部的偏移量
        //     var nl = nx - (dragPos.x - dragPos.l)
        //     var nt = ny - (dragPos.y - dragPos.t)
        //     oldCanvas.style.left = nl + 'px'
        //     oldCanvas.style.top = nt + 'px'
        //     newCanvas.style.left = nl + 'px'
        //     newCanvas.style.top = nt + 'px'
        //     bgCanvasBottom.style.left = nl + 'px'
        //     bgCanvasBottom.style.top = nt + 'px'
        //     downloadCanvas.style.left = nl + 'px'
        //     downloadCanvas.style.top = nt + 'px'
        // }
        //     document.onmouseup = (e) => {
        //         dragPos.isDown = false
        //     }
        // },
        checkTarget (e) {
        if (this.activeNameNum === 5) {
            this.actionDrag()
        }
        },
        // 笔画操作
        actionBrush () {
        let { ctx, uploadCtx, eraserCtx, newCtx } = this.getElement()
        let brushPos = {
            x: 0,
            y: 0,
            flag: false,
        }
        window.onmousedown = (e) => {
            if (this.loading) return // 如果存在加载状况， 证明状态还未返回
            if (!(e.target.getAttribute('class') && e.target.getAttribute('class').includes('round-box'))) return
            if ([1, 2, 3].includes(this.activeNameNum)) {
            brushPos.flag = true
            }
            let leftStart = $('#old-canvas').offset().left - $(window).scrollLeft() // 获取图片宽度初始位置
            let leftEnd =
            leftStart + $('#old-canvas').innerWidth() * this.canvasConfig.scale // 获取图片最大宽度
            let topStart = $('#old-canvas').offset().top  - $(window).scrollTop();
            let topEnd =
            topStart + $('#old-canvas').innerHeight() * this.canvasConfig.scale
            if (
            e.x >= leftStart &&
            e.x <= leftEnd &&
            e.y >= topStart &&
            e.y <= topEnd
            ) {
            
            let x = (e.clientX - leftStart) / this.canvasConfig.scale
            let y = (e.clientY - topStart) / this.canvasConfig.scale

            brushPos.x = x
            brushPos.y = y
            }
        }

        window.onmousemove = (e) => {
           
            if (this.loading) return // 如果存在加载状况， 证明状态还未返回
            let width = $('.round-box').width() / 2
            if ($('#old-canvas').offset()) {
            // old-canvas 四角坐标
            let leftNum1 = $('#old-canvas').offset().left - $(window).scrollLeft()
            let leftNum2 = leftNum1 + $('#old-canvas').innerWidth() * 0.5
            let topNum1 = $('#old-canvas').offset().top - $(window).scrollTop()
            let topNum2 = topNum1 + $('#old-canvas').innerHeight() * 0.5
           
            if (e.x >= leftNum1 && e.x <= leftNum2 && e.y >= topNum1 && e.y <= topNum2) {
                 $('.old-can').css({
                    cursor: 'none'
                })
                $('.round-box').css({
                    // 距离计算  width是边框除以2需要居中 conLeft是整个内容距离左边的偏移量
                    left: e.clientX -leftNum1 - width,
                    top: e.clientY - topNum1 - width,
                    display: 'block',
                })
            } else {
                $('.old-can').css({
                cursor: 'default'
                })
                $('.round-box').css({
                display: 'none'
                })
            }
            }
            if (!brushPos.flag) return
            let { left, top } = $('#old-canvas').offset()
            let x = (e.clientX - left + $(window).scrollLeft()) /  0.5
            let y = (e.clientY - top + $(window).scrollTop()) / 0.5

            if ([1, 2].includes(this.activeNameNum)) {
            ctx.beginPath()
            ctx.globalCompositeOperation = this.canvasBrushType.globalCompositeOperation
            ctx.lineWidth =
                this.canvasBrushType.lineWidth / 0.5
            ctx.strokeStyle = this.canvasBrushType.color
            ctx.lineJoin = 'round'
            ctx.globalAlpha = 1
            ctx.moveTo(brushPos.x, brushPos.y)
            ctx.lineTo(x, y)
            ctx.closePath()
            ctx.stroke()
            } else if (this.activeNameNum === 3) {
            let imgX =
                x - this.canvasBrushType.lineWidth / 0.5 / 2
            let imgY =
                y - this.canvasBrushType.lineWidth / 0.5 / 2
            let imageWidth =
                this.canvasBrushType.lineWidth / 0.5
            let nowImg = eraserCtx.getImageData(imgX, imgY, imageWidth, imageWidth)
            ctx.putImageData(nowImg, imgX, imgY)
            }
            uploadCtx.beginPath()
            uploadCtx.globalCompositeOperation = this.canvasBrushType.globalCompositeOperation
            uploadCtx.lineWidth =
            this.canvasBrushType.lineWidth / 0.5
            uploadCtx.strokeStyle = this.canvasBrushType.color
            uploadCtx.lineJoin = 'round'
            uploadCtx.globalAlpha = 1
            uploadCtx.moveTo(brushPos.x, brushPos.y)
            uploadCtx.lineTo(x, y)
            uploadCtx.closePath()
            uploadCtx.stroke()

            brushPos.x = x
            brushPos.y = y
        }

        document.onmouseup = () => {
            if (!brushPos.flag) return
            brushPos.flag = false
            // 这里需要调用 ajax   根据ajax返回操作结果用于保存
            let { uploadCanvas, oldCanvas, newCanvas } = this.getElement()

            if (this.loading) return
            let dataURL = uploadCanvas.toDataURL()
            this.loading = true
            let _this = this
            let formdata = new FormData();
            formdata.append('request_id', _this.request_id)
            formdata.append('mask', dataURL);
            formdata.append('origin', 3);
            cutOutImage.refineCutout(formdata).then((res)=>{
                if(res.status == 1){
                    let { image } = res.data
                // this.newImageUrl = image
                _this.newCanvas.clear()
                fabric.Image.fromURL(
                image,
                (newImg) => {
                  
                    // 后期如果存在截图 需要使用
                    _this.newCanvas.add(newImg)

                    setTimeout(() => {
                    _this.history()
                    _this.loading = false
                     
                    }, 0)

                },
                {
                    crossOrigin: 'Anonymous',
                }
                )
                }
            })
            
           
        }
        },
        // 切换
        toggleActiveName (val) {
            this.activeNameNum = val
            if (val === 1) {
                this.optionBrush('#67c23a', 'source-over')
                this.actionBrush()
            } else if (val === 2) {
                this.optionBrush('#f56c6c', 'source-over')
                this.actionBrush()
            } else if (val === 3) {
                this.optionBrush('#FFF', 'destination-out')
                this.actionBrush()
            } else if (val === 5) {
                this.actionDrag()
            }
            this.brushStatus = false // 笔画调整大小的框
        },
        optionBrush (color, Operation) {
        this.canvasBrushType.color = color
        this.canvasBrushType.globalCompositeOperation = Operation
        },
        // editInputVal (newVal) {
        //   this.rangeVal = newVal
        //   this.inputVal = newVal
        //   this.canvasBrushType.lineWidth = newVal
        // },

        toHref () {
        // 帮助跳转链接
        window.open(
            'https://www.yuque.com/docs/share/caf46076-b5b5-4e7f-bea6-777be758b560?#'
        )
        },
        // 获取clip操作条的事件
        getClipOperate (val) {
        if (typeof val === 'string') {
            this[val]()
        } else {
            this.toggleActiveName(val)
        }

        },
        suitable () {
        // 合适大小
        let status = this.errorInfo()
        if (!status) return
        let { oldCanvas, newCanvas, bgCanvasBottom } = this.getElement()
        this.canvasConfig.scale = this.canvasConfig.oldImgScale
        let { oldOffsetTop, oldOffsetLeft } = this.canvasConfig
        oldCanvas.style.top = `${oldOffsetTop}px`
        oldCanvas.style.left = `${oldOffsetLeft}px`
        newCanvas.style.top = `${oldOffsetTop}px`
        newCanvas.style.left = `${oldOffsetLeft}px`
        bgCanvasBottom.style.top = `${oldOffsetTop}px`
        bgCanvasBottom.style.left = `${oldOffsetLeft}px`
        },
        reality () {
        // 实际大小
        this.canvasConfig.scale = 1
        },
        sub () {
        // 缩放
        let status = this.errorInfo()
        if (!status) return
        let config = this.canvasConfig
        if (config.scale > 0.2) {
            config.scale = Number((config.scale - 0.1).toFixed(2))
            config.scale = Math.max(0.2, config.scale)
        }
        },
        big () {
        // 放大
        let status = this.errorInfo()
        if (!status) return
        let config = this.canvasConfig
        if (config.scale < 3) {
            config.scale = Number((config.scale + 0.1).toFixed(2))
            config.scale = Math.min(3, config.scale)
        }
        },
        back () {
        // 后退
        if (this.step === -1) {
            return
        }
        this.step--
        this.step = Math.max(-1, this.step)

        let url = this.step === -1 ? this.oldImageUrl : this.oldImgList[this.step]
        let newUrl = this.step === -1 ? this.newImageUrl : this.newImgList[this.step]
        let uploadUrl = this.step === -1 ? '' : this.uploadImgList[this.step]
        this.loading = true

        this.oldCanvas.clear()
        this.newCanvas.clear()
        this.uploadCanvas.clear()

        fabric.Image.fromURL(
            url,
            (oldImg) => {

            this.oldCanvas.add(oldImg)
            fabric.Image.fromURL(
                newUrl,
                (newImg) => {

                this.newCanvas.add(newImg)

                fabric.Image.fromURL(
                    uploadUrl,
                    (uploadImg) => {

                    this.uploadCanvas.add(uploadImg)
                    this.loading = false
                    },
                    {
                    crossOrigin: 'Anonymous',
                    }
                )
                },
                {
                crossOrigin: 'Anonymous',
                }
            )
            },
            {
            crossOrigin: 'Anonymous',
            }
        )
        },
        next () {
        //下一步
        if (this.step > this.oldImgList.length - 1) {
            return
        }
        this.step++
        this.step = Math.min(this.oldImgList.length - 1, this.step)

        let url = this.oldImgList[this.step]
        let newUrl = this.newImgList[this.step]
        let uploadUrl = this.uploadImgList[this.step]

        if (url !== undefined && newUrl !== undefined) {
            this.loading = true

            this.oldCanvas.clear()
            this.newCanvas.clear()
            this.uploadCanvas.clear()

            fabric.Image.fromURL(
            url,
            (oldImg) => {
                this.oldCanvas.add(oldImg)
                fabric.Image.fromURL(
                newUrl,
                (newImg) => {
                    this.newCanvas.add(newImg)

                    fabric.Image.fromURL(
                    uploadUrl,
                    (uploadImg) => {
                        this.uploadCanvas.add(uploadImg)
                        this.loading = false
                    },
                    {
                        crossOrigin: 'Anonymous',
                    }
                    )
                },
                {
                    crossOrigin: 'Anonymous',
                }
                )
            },
            {
                crossOrigin: 'Anonymous',
            }
            )
        }
        },
        brushShow () {
        // 画笔调整
        this.brushStatus = !this.brushStatus
        },
        // changeInputVal () {
        //   // 画笔值更新
        //   let newVal = Number(this.inputVal)
        //   var re = new RegExp('^[0-9]*[1-9][0-9]*$')
        //   if (!re.test(newVal) || newVal > 100 || newVal < 12) {
        //     this.rangeVal = 12
        //     this.inputVal = 12
        //   } else {
        //     this.rangeVal = newVal
        //     this.inputVal = newVal
        //     this.canvasBrushType.lineWidth = newVal
        //   }
        // },
        changeBrushWidth (val) {
        this.canvasBrushType.lineWidth = val
        },
        history () {
        // 操作的历史记录  如果为true 代表操作失败， 需要回退
        let { uploadCanvas, newCanvas, oldCanvas } = this.getElement()
        this.step++
        // 如果操作前进了，   那么就需要调整了。
        if (this.step < this.oldImgList.length) {
            this.oldImgList.length = this.step
            this.newImgList.length = this.step
            this.uploadImgList.length = this.step
        }

        setTimeout(() => {
            let newDataURL = newCanvas.toDataURL()
            let oldDataURL = oldCanvas.toDataURL()
            let uploadDataURL = uploadCanvas.toDataURL()

            this.newImgList.push(newDataURL)
            this.oldImgList.push(oldDataURL)
            this.uploadImgList.push(uploadDataURL)
        }, 100)
        },
        defaultImage () {
        // 恢复原图
        let { uploadCanvas, newCanvas, oldCanvas } = this.getElement()
        // let url = this.step !== -1 ? this.oldImgList[this.step] : this.oldImageUrl
        this.loading = true

        let newDataURL = newCanvas.toDataURL()

        if (newDataURL === this.oldImageUrl) {
            this.$message.closeAll()
            this.$message({
            message: '上一步已经恢复原图！',
            type: 'warning'
            })
            this.loading = false
        } else {
            this.oldCanvas.clear()
            this.newCanvas.clear()
            this.uploadCanvas.clear()

            fabric.Image.fromURL(
            this.oldImageUrl,
            (oldImg) => {
                this.oldCanvas.add(oldImg)
                this.newCanvas.add(oldImg)

                setTimeout(() => {
                this.history() // 恢复原图需要获取fabric数据
                this.loading = false
                }, 0)

            },
            {
                crossOrigin: 'Anonymous',
            }
            )

        }

        },
        success () {
        // 完成
        let { uploadCanvas } = this.getElement()
        let toDataURL = uploadCanvas.toDataURL()
        },
        close () {
        // 关闭时  所有需要初始化
        },
        errorInfo (str = '请等待图片加载完毕!') {
        if (this.loading) {
            this.$message.closeAll()
            this.$message({
            message: `${str}`,
            type: 'warning'
            })
            return false
        }
        return true
        },
        changeBackground () {
        // 设置背景图
        let _setBackgroundImage = img_url => {
            fabric.Image.fromURL(img_url, oImg => {

            let backGroundOptions = {}

            // 图片比例
            let imgScale = this.bgCanvasBottom.width / this.bgCanvasBottom.height
            // 背景比例
            let bgImgScale = oImg.width / oImg.height
            /**
             * 宽图，bgImgScale > imgScale 背景更宽/ bgImgScale < imgScale 背景更窄
             * 竖图，bgImgScale > imgScale 背景更矮/ bgImgScale < imgScale 背景更高
             */

            if (bgImgScale >= imgScale) {
                backGroundOptions = {
                scaleX: this.bgCanvasBottom.height / oImg.height,
                scaleY: this.bgCanvasBottom.height / oImg.height,
                left: this.bgCanvasBottom.width / 2,
                top: 0,
                originX: 'center'
                }
            } else {
                backGroundOptions = {
                scaleX: this.bgCanvasBottom.width / oImg.width,
                scaleY: this.bgCanvasBottom.width / oImg.width,
                left: 0,
                top: this.bgCanvasBottom.height / 2,
                originY: 'center'
                }
            }

            oImg.set(backGroundOptions)

            this.bgCanvasBottom.setBackgroundImage(oImg, this.bgCanvasBottom.renderAll.bind(this.bgCanvasBottom))
            // this.loading = false
            }, {
            crossOrigin: 'Anonymous',
            })
        }

        let content = ''
        let type = ''

        if (this.rootBgData.content) {
            content = this.rootBgData.content
            type = this.rootBgData.type
        }

        if (type === 'img') {
            // 清除背景色
            this.bgCanvasBottom.setBackgroundColor(null, this.bgCanvasBottom.renderAll.bind(this.bgCanvasBottom))
            _setBackgroundImage(content)
        } else if (type === 'color') {
            // 清除背景图
            this.bgCanvasBottom.setBackgroundImage(null, this.bgCanvasBottom.renderAll.bind(this.bgCanvasBottom))
            // 设置颜色
            this.bgCanvasBottom.setBackgroundColor(content, this.bgCanvasBottom.renderAll.bind(this.bgCanvasBottom))
        } else {
            _setBackgroundImage(this.defaultBgUrl)
        }

        },

        // 获取newImg的base64
        getNewImageBase64 () {
        return this.newCanvas.toDataURL({
            width: this.newCanvas.width,
            height: this.newCanvas.height,
            left: 0,
            top: 0,
            format: 'png',
        })
        },
        composeImage (type) {
        // 获取抠图
        let cutoutUrl = this.newCanvas.toDataURL({
            width: this.newCanvas.width,
            height: this.newCanvas.height,
            left: 0,
            top: 0,
            format: 'png',
        })
        // 获取背景图
        let bgUrl = this.bgCanvasBottom.toDataURL({
            width: this.bgCanvasBottom.width,
            height: this.bgCanvasBottom.height,
            left: 0,
            top: 0,
            format: 'png',
        })

        // 组合图片
        fabric.Image.fromURL(
            cutoutUrl,
            (oldImg) => {
            this.downloadCanvas.clear()
            this.downloadCanvas.add(oldImg)

            // 不是透明背景时，组合背景
            if (this.rootBgData.content) {
                this.downloadCanvas.setBackgroundImage(bgUrl, this.downloadCanvas.renderAll.bind(this.downloadCanvas))
            }
            },
            {
            crossOrigin: 'Anonymous',
            }
        )
        type === 'download' ? this.download() : this.upload()
        },
        download () {
            setTimeout(() => {
                let imageUrl = this.downloadCanvas.toDataURL({
                width: this.downloadCanvas.width,
                height: this.downloadCanvas.height,
                left: 0,
                top: 0,
                format: 'png',
                })
                const link = document.createElement('a')
                link.download = '抠图' + $.mytools.GetQueryString('img_id') + '.png'
                link.href = imageUrl
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)

                statistics.__sendEvent({
                statsMark: '抠图下载本地次数',
                projectPage: '24',
                projectArea: '48',
                eventArea: '48',
                eventType: '3',
                eventId: '78',
                eventName: 'cutout_download_num',
                })
            }, 500)
        },
        upload () {
            setTimeout(() => {
                let imageUrl = this.downloadCanvas.toDataURL({
                width: this.downloadCanvas.width,
                height: this.downloadCanvas.height,
                left: 0,
                top: 0,
                format: 'png',
                })
                this.$emit('save-blob', imageUrl)
            }, 500)
        }
    },
    created() {
     
    
    },
}
</script>
<style lang="scss" scoped>
    .editor{
        width:1400px;
        margin: auto;
        border-radius: 8px;
        overflow: hidden;
        background-color: #171a27;
        position: relative;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: normal;
        justify-content: normal;
        -ms-flex-align: normal;
        align-items: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        margin-bottom: 16px;
        .left{
           width: 448px;
            padding: 50px 24px;
            position: relative;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: justify;
            justify-content: space-between;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            justify-content: center;
            .header{
                position: relative;
                z-index: 2;
                width: 100%;
                img{
                    width: 100%;
                    height: auto;
                    margin: 0;
                }
                canvas{
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 2;
                }
                .list{
                    padding: 4px 0 0;
                    margin-left: -4px;
                    margin-right: -4px;
                    display: -ms-flexbox;
                    display: flex;
                    -ms-flex-pack: start;
                    justify-content: flex-start;
                    -ms-flex-align: center;
                    align-items: center;
                    -ms-flex-direction: row;
                    flex-direction: row;
                    -ms-flex-wrap: nowrap;
                    flex-wrap: nowrap;
                         button{
                            border: none;
                            padding: 0;
                            margin: 4px;
                            overflow: hidden;
                            position: relative;
                            -ms-flex: 1 1;
                            flex: 1 1;
                            &:first-child{
                                margin-top: 0;
                            }
                            cursor: pointer;
                            img{
                                width: 100%;
                                height: 100%;
                                position: absolute;
                                top: 0;
                                left: 0;
                                -o-object-fit: cover;
                                object-fit: cover;
                                -o-object-position: center;
                                object-position: center;
                                -webkit-user-select: none;
                                -moz-user-select: none;
                                -ms-user-select: none;
                                user-select: none;
                            }
                            &::before{
                                content: '';
                                display: block;
                                padding-top: 100%;
                            }
                        }
            .photoActive{
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    z-index: 2;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    border: 4px solid transparent;
                    -webkit-transition: border-color ease-in-out 280ms;
                    -o-transition: border-color ease-in-out 280ms;
                    transition: border-color ease-in-out 280ms;
                    border-color: #5986ff;
                }
            }
                }
                .button{
                    text-align: center;
                    button{
                        cursor: pointer;
                        padding: 12px 50px;
                        border-radius: 4px;
                        font-size: 14px;
                        line-height: 20px;
                        font-weight: 400;
                        outline: none;
                        border: none;
                        color: #fff;
                        background-color: #5986ff;
                    }
                }
                .tool{
                    position: relative;
                    width: 100%;
                    padding: 11px 0 16px;
                    display: -ms-flexbox;
                    display: flex;
                    -ms-flex-pack: justify;
                    justify-content: space-between;
                    -ms-flex-align: center;
                    align-items: center;
                    -ms-flex-direction: row;
                    flex-direction: row;
                    -ms-flex-wrap: nowrap;
                    flex-wrap: nowrap;
                    ._2Jkr7{
                        padding: 5px;
                        border: none;
                        background-color: transparent;
                        border-radius: 0;
                        height: 30px;
                        font-size: 12px;
                        line-height: 24px;
                        color: #515666;
                        -webkit-transition: color ease-in-out 280ms;
                        -o-transition: color ease-in-out 280ms;
                        transition: color ease-in-out 280ms;
                    }
                    ._3yhJv {
                        cursor: pointer;
                        outline: none;
                    }
                }
            }
       
        }
        .right{
          flex: 1 1;
            padding: 50px;
            height: 666px;
            background-color: #202537;
            position: relative;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: center;
            justify-content: center;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            .workbeach{
                position: relative;
                width: 800px;
                z-index: 1;
                height:532px;
                overflow: hidden;
                background-image: url('data:image/png;base64,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');
                background-color: #fff;
                .item{
                    position: relative;
                    z-index: 2;
                    width: 100%;
                    img{
                            width: 100%;
                            height: auto;
                            margin: 0;
                    }
                }
            }
            #download-canvas,#bg-canvas-bottom,#new-canvas{
                position: absolute;
                width: 852px;
                height: 570.58px;
                top:0;
                left: 0;
            }
        }
    }
    ._1JQcs{
        opacity: 1;
        color: #5986ff !important;
    }
  ._1JQcs svg path{
        fill: #5986ff;
  }
    .round-box {
      position: absolute;
      top: 0;
      left: 0;
      display: none;
      z-index: 100;
    }
    .iconfont.icon-jia {
        color: transparent;
        cursor: auto;
    }
    .iconfont.icon-quchuicon{
         color: transparent;
        cursor: auto;
    }
    .iconfont.icon-cachuicon{
 color: transparent;
        cursor: auto;
    }
</style>